/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { ClearableSearchField } from "components/SearchField/SearchField";
import React, { useEffect, useState } from "react";

import {
  AppBar,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";

import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import {
  deleteParameterListByID,
  getParameterById,
  getParameterList,
  saveParameter,
  updateParameterByID,
} from "utils/superAdminApi";
import LoadingModal from "../../../components/LoadingModel/loadingModal";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

function EditParameter() {
  const { id } = useParams();

  const defaultHrMarginLeft = 20;
  const [table, setTable] = useState("parameter");
  const [hrWidth, setHrWidth] = useState(151);
  const [hrMarginLeft, setHrMarginLeft] = useState(defaultHrMarginLeft);
  const [showParameter, setShowParameter] = useState(false);
  // const [showPlanCostTable, setShowPlanCostTable] = useState(false)
  const [showParameterList, setShowParameterList] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [parameterNameErr, setParameterNameErr] = useState(false);
  const [parameterCodeErr, setParameterCodeErr] = useState(false);
  const [screenName, setScreenName] = useState("Add Parameter");
  const [totalRows, setTotalRows] = useState(0);
  const [disableColor, setDisableColor] = useState(false);

  const [customerReload, setCustomerReload] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [values, setValues] = React.useState({
    searchParameter: "",
    parameterStatus: "Active",
  });
  const [listValues, setListValues] = React.useState({
    searchParameter: "",
    parameterStatus: "Active",
    searchParameterList: [
      "parameterListStatus",
      "parameterListSequence",
      "parameterListCode",
      "parameterListName",
    ],
    parameterListStatus: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
  });

  const handleChange = (name) => (event) => {
    if (name == "parameterCode") {
      setValues({ ...values, [name]: event.target.value.toUpperCase() });
      return;
    }

    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };
  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  useEffect(() => {
    if (id !== undefined) {
      setScreenName("Edit Parameter");
      values._id = id;
      getParameterById(
        values,
        (data) => {
          if (data.Result_Output.length > 0) {
            let res = data.Result_Output[0];
            setValues(res);
          }
        },
        dispatch
      );
    }
    getRight();
  }, []);

  async function getRight() {
    let right = await getScreenRight("Parameter Lists");
    if (right === "Full Access") setDisableColor(false);
    else setDisableColor(true);
  }
  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === "parameter_list") {
      setTable("parameter_list");
    }
    if (table === "parameter") {
      setShowParameter(true);
      setShowParameterList(false);
      setTabValue(0);
      setHrWidth(163);
      setHrMarginLeft(defaultHrMarginLeft);
    } else if (table === "parameter_list") {
      setShowParameter(false);
      setShowParameterList(true);
      setHrWidth(135);
      setTabValue(1);
      fetchParameterList();
      setHrMarginLeft(229);
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);

  useEffect(() => {
    fetchParameterList();
  }, [customerReload, listValues.parameterListStatus]);

  const clearErrState = () => {
    setParameterCodeErr(false);
    setParameterNameErr(false);
  };
  let mandateFlag;
  const updatedParameter = () => {
    clearErrState();
    mandateFlag = false;
    console.log("asdsadsadasdsad", values);
    mandateFlag =
      validateField(values.parameterName, setParameterNameErr) || mandateFlag;
    mandateFlag =
      validateField(values.parameterCode, setParameterCodeErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id !== undefined ? updateParameterByID : saveParameter;
    apiFunction(
      values,
      (data) => {
        if (data.Result_Status) {
          showResMsg(
            id === undefined ? genericMessage.added : genericMessage.updated,
            1000,
            data.Result_Status,
            navigate,
            "/parameter"
          );
        } else {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
        }
      },
      dispatch
    );
  };

  const fetchParameterList = async () => {
    listValues.parameterId = id;
    getParameterList(
      listValues,
      (data) => {
        if (data.Result_Status) {
          setTotalRows(data.Result_Output.totalDocs);
          setRows(data.Result_Output.docs);
        } else {
          setTotalRows(0);
          setRows([]);
        }
      },
      dispatch
    );
  };

  useEffect(() => {
    if (listValues.filterValues.length == "") {
      fetchParameterList();
    }
  }, [listValues.filterValues]);

  const handleDeleteDialogeClick = async (_id) => {
    listValues._id = _id;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteParameterList();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteParameterList = async () => {
    sessionStorage.setItem("PARA_TABLE", "parameter_list");
    deleteParameterListByID(
      listValues,
      (data) => {
        if (data.Result_Status) fetchParameterList();
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  const handlePageChange = (page) => {
    listValues.page = page;
    setCustomerReload(!customerReload);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    listValues.page = page;
    listValues.limit = newPerPage;
    setCustomerReload(!customerReload);
  };
  const handleSort = async (type, value) => {
    listValues.sortingType = value;
    listValues.sortingField = type;
    setCustomerReload(!customerReload);
  };

  const parameter = (
    <>
      {showParameter && (
        <MDBox mt={6} mb={3}>
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={6} spacing={6}>
              <Card sx={{ boxShadow: "none" }}>
                <MDBox
                  // pt={4}
                  // pb={3}
                  p={0.6}
                  mb={0.9}
                  px={2}
                >
                  <Grid container mt={-2.1} columnSpacing={5}>
                    <Grid item xs={12} lg={12}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Parameter Name"
                            variant="outlined"
                            fullWidth
                            autoFocus={true}
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 50,
                            }}
                            disabled={id ? true : false}
                            value={values.parameterName}
                            onChange={handleChange("parameterName")}
                            InputLabelProps={{ shrink: true }}
                          />
                          {parameterNameErr ? (
                            <span style={errMsg}>
                              Parameter Name can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Parameter Code"
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              // pattern: "^[A-Z0-9]+$",
                              maxLength: 20,
                            }}
                            disabled={id ? true : false}
                            value={values.parameterCode}
                            onChange={handleChange("parameterCode")}
                          />{" "}
                          {parameterCodeErr ? (
                            <span style={errMsg}>
                              Parameter Code can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Parameter Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          name="userType"
                          id="demo-simple-select"
                          style={{ minHeight: "3em" }}
                          // disabled={id ? true : false}
                          label="Parameter Status"
                          value={values.parameterStatus}
                          onChange={handleChange("parameterStatus")}
                        >
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            mt={1}
            // columnSpacing={4}
            columnSpacing={{ xs: 2, md: 4, lg: 4 }}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.68}>
              <Link to={"/parameter"}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                  style={{ width: "165px", height: "40px" }}
                >
                  Close
                </MDButton>
              </Link>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.68}>
              <MDButton
                onClick={updatedParameter}
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                style={{ width: "165px", height: "40px" }}
              >
                Save
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      )}
    </>
  );
  const parameterListCol = [
    {
      name: "Parameter List Name",
      selector: (row) => row.parameterListName,
      sortable: true,
      sortField: "parameterListName",
      left: true,
    },
    {
      name: "Parameter List Code",
      selector: (row) => row.parameterListCode,
      sortable: true,
      sortField: "parameterListCode",
      center: true,
    },
    {
      name: "Parameter List Sequence",
      selector: (row) => row.parameterListSequence,
      sortable: true,
      sortField: "parameterListSequence",
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.parameterListStatus,
      sortable: true,
      sortField: "parameterListStatus",
      center: true,
    },

    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item style={{ marginLeft: "-20px" }}>
              <Link to={`/parameter/editParameterList/${row._id}?pr=${id}`}>
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>
          </Grid>
        </>
      ),
    },
  ];
  const parameterList = (
    <>
      {showParameterList && (
        <>
          <Grid container display={"flex"} justifyContent="end" mt={3} gap={2}>
            <Grid lg={2.5} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={listValues.parameterListStatus}
                  onChange={(e) =>
                    setListValues({
                      ...listValues,
                      parameterListStatus: e.target.value,
                    })
                  }
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={listValues.filterValues}
                onChange={(e) =>
                  setListValues({ ...listValues, filterValues: e.target.value })
                }
                onKeyUp={(e) => {
                  if (e.key === "Enter") setCustomerReload(!customerReload);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.5rem  0.5rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={() => setCustomerReload(!customerReload)}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: "16px" }}>
              <Link to={`/parameter/addParameterList/${id}`}>
                <MDButton
                  variant="contained"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color={disableColor ? "secondary" : "success"}
                  style={{ height: "44.11px", width: "99px" }}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              columns={parameterListCol}
              data={rows}
              selectableRows={false}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </>
      )}
    </>
  );

  const renderTable = () => {
    return (
      <>
        {parameter}
        {/* {planCostTable} */}
        {parameterList}
      </>
    );
  };
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container mt={2}>
          <Grid item xs={12} md={6} lg={4} px={2} mb={-1.4}>
            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                className="tab-container"
                indicatorColor={"primary"}
                sx={{
                  "& .Mui-selected": {
                    color: "#fff !important",
                    background: `${barColor} !important`,
                  },
                  ".MuiTabs-indicator": {
                    background: `${barColor} !important`,
                  },
                }}
              >
                <Tab onClick={() => setTable("parameter")} label="Parameter" />
                <Tab
                  disabled={id !== undefined ? false : true}
                  onClick={() => setTable("parameter_list")}
                  label="Parameter Lists"
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
        {renderTable()}
      </Card>

      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default EditParameter;
